sn-related-links-type-1 .related-links-type-1__tags-list {
  // Base list layout (previously provided by the related-links-type-1 base component,
  // now rendered inline so the heading is a first-class slot — no double slotting).
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--spacing-lg);
  margin-top: calc(var(--spacing-6xl) - var(--spacing-xs));
  margin-bottom: calc(-1 * var(--spacing-xs));
  list-style: none;
  padding: 0;

  @media (width <= 768px) {
    grid-template-columns: 1fr;
  }

  @include below-desktop {
    gap: var(--spacing-sm);
    margin-top: var(--spacing-2xl);
  }
}

// Semantic <li> kept layout-neutral so the anchor remains the grid item.
sn-related-links-type-1 .related-links-type-1__tags-list-li {
  display: contents;
}

sn-related-links-type-1 .related-links-type-1__tags-list-item {
  display: flex;
  align-items: center;
  padding: 0.75rem 2rem;
  border: 1px solid $color-brand-primary-darkest;
  border-radius: 4px;
  text-decoration: none;
  color: inherit;
  transition: all 0.3s ease;
  min-width: 0;
  overflow: hidden;

  // On mobile reserve the height of a two-line label so every card is the same
  // size; `align-items: center` then vertically centers shorter (one-line) labels.
  // border-box: min-height = 2 text lines (2 × 1.4rem) + vertical padding + borders.
  @media (width <= 768px) {
    min-height: calc((1.4rem * 2) + (0.75rem * 2) + 2px);
  }

  &:hover {
    border-color: $color-brand-primary-main;

    .related-links-type-1__link-icon svg {
      fill: $color-brand-primary-main;
    }
  }
}

.related-links-type-1__link-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  font-weight: 700;

  // On mobile the list is a single column. Allow the label to wrap to a maximum
  // of two lines (truncating with an ellipsis beyond that) and reserve the full
  // two-line height so every card is the same size as a two-line one — even when
  // its own label only needs one line.
  @media (width <= 768px) {
    // `-webkit-line-clamp` requires the box layout; keep it so the 2-line
    // clamp + ellipsis works. Vertical centering can't be done here (box-pack is
    // ignored while line-clamp is active) — it's handled on the card via
    // `align-items: center` + a reserved two-line `min-height` instead.
    white-space: normal;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    line-height: 1.4;
  }
}

.related-links-type-1__link-icon {
  display: inline-flex;
  align-items: center;
  margin-right: 0.75rem;
  flex-shrink: 0;

  svg {
    fill: $color-brand-primary-darkest;
    transition: fill 0.3s ease;
  }
}
